const React = require("react");
const formatTime = require("mn-utils/formatTime");
const withReDelay = require("mn-utils/withReDelay");
const viewport$ = require("mn-utils/browser/emitters/viewport");

const {IntervalFilterReferral, initFilter} = require('../../../dumb/IntervalFilterCustom');
const IntervalFilter = require("../../../dumb/IntervalFilter");
const ReportDownload = require("../../../dumb/ReportDownload/ReferralRD");
const Caption = require("../../../dumb/Caption/C");
const RefCell = require("../../../dumb/TableHeadCell/RefCell");

const TableItem = require('./components/TableItem');
const {apiV2ReferralPayoutsList} = require("../../../../api/referral/payouts");

const {
  getRFC3339,
} = formatTime;
const {
  getDateRange,
} = IntervalFilter;

const filter$ = initFilter();

const getParams = (filter) => {
  const {
    from,
    to,
  } = getDateRange(filter);

  return {
    search: filter.search || null,
    from: from ? getRFC3339(from) : null,
    to: to ? getRFC3339(to) : null
  };
};

module.exports = require('../../../../utils/virtualOutputComponentProvider')({
  state: {
    filter: filter$,
    viewport: viewport$.throttle(100),
  },
  rowHeight: 60,
  nodata: (<div
    className="f16 fw4 cC mt20 ttU tc w"
  >No data</div>),
  request: require('../../../../api/referral/payouts').apiV2ReferralPayoutsList,
  getParams: (self) => getParams(self.state.filter),
  wrapper(render, setState, self) {
    const update = withReDelay(self.update, 1000);
    function handleChangeFilter(filter) {
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }
    return (state) => {
      const filter = state.filter;
      const noData = !state.data || !state.data.count;

      return (
        <div>
          <div className="h48 layoutRow fhaB fvaC">
            <div>
              <Caption>Payouts Transfers</Caption>
              <div className="f10 fw4 lh14">
                Your monthly commissions are calculated and paid out to your bank account when you meet the withdrawal minimum threshold.
              </div>
            </div>
            {!noData && (
              <ReportDownload
                className="pl10"
                urlPrefix="/v2/console/report/"
                filter={getParams(filter)}
                disabled={noData}
              />
            )}
          </div>
          <IntervalFilterReferral
            className="mt24 mb25"
            data={filter}
            onChange={handleChangeFilter}
            search={{
              className: 'w310',
              placeholder: 'Search by Email / Amount / Order'
            }}
          />
          <div className="h100vh-450 rlv">
            <div className="abs sh sb10 st0 ov">
              <div className="abs s ovxA">
                <div className="w rlv h">
                  <div className="w abs bgE layoutRow fhaS fvaC r9 ov w1/4>1">
                    <RefCell>Type</RefCell>
                    <RefCell>Amount</RefCell>
                    <RefCell>Date and Time</RefCell>
                    <RefCell>Status</RefCell>
                  </div>
                  <div className="abs sh st45 sb c0>.CircularProgress">
                    {render(TableItem)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
});